import React, {useState} from 'react';

const LINKS = [
    {href: '#top', label: 'Главная'},
    {href: '#director', label: 'Руководитель'},
    {href: '#about', label: 'Об организации'},
    {href: '#volunteers', label: 'Волонтёры'},
    {href: '#projects', label: 'Проекты'},
    {href: '#contacts', label: 'Контакты'},
];

const Navbar = () => {
    const [open, setOpen] = useState(false);

    const close = () => setOpen(false);

    return (
        <nav className="site-nav">
            <div className="container nav-inner">
                <a href="#top" className="brand" onClick={close}>
                    <span className="brand-line">Центр семьи и молодёжи</span>
                    <span className="brand-name">«Содействие»</span>
                </a>

                <button
                    className={`nav-toggle${open ? ' open' : ''}`}
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Меню"
                    aria-expanded={open}
                >
                    <span/><span/><span/>
                </button>

                <ul className={`nav-menu${open ? ' open' : ''}`}>
                    {LINKS.map((link) => (
                        <li key={link.href}>
                            <a href={link.href} onClick={close}>{link.label}</a>
                        </li>
                    ))}
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;
